<script>
import { store } from '../../functions/mixins';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiLoading from '../ui/Loading';
import UiScrollbar from '../ui/Scrollbar';
import UiButton from '../ui/Button';
import deepEqual from 'deep-equal';
import {
    pressengerControl, getNotificationImageURL, getStudioImageURL, getCsrf,
} from '../../functions/sdk';
import * as crossPopup from '../../functions/crossPopup';
import moment from 'moment';
import { getExtension } from '../../functions/mime';

export default {
    mixins: [store],
    props: {
        value: Object,
        skipStep: Function,
        next: Function,
        setStep: Function,
    },
    components: {
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiScrollbar,
        UiButton,
    },
    data: () => ({
        data: null,
        items: [],
        loading: false,
        uploading: false,
        uploadError: false,
        uploadDuplicateFilename: false,
        popupId: 0,
        popupName: null,
        popupLoading: false,
    }),
    computed: {
        sorted() {
            return this.items === null ? [] : this.items.sort((a, b) => {
                const aid = a.id === null ? Number.MAX_SAFE_INTEGER : a.id;
                const bid = b.id === null ? Number.MAX_SAFE_INTEGER : b.id;
                return bid - aid;
            });
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        this.fetch();
        if (this.data.isModNews) {
            this.openModNews();
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            pressengerControl.getNotificationImages().then(items => {
                this.items = items.filter(i => i.fileName.indexOf('android_modnewsbackground') === -1);
                this.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    this.fetch();
                }, 2000);
            });
        },
        openStudio() {
            if (!this.popupId) {
                document.documentElement.scrollTop = 0;
                document.body.className = 'DisableScrolling';
                this.popupName = 'studio'
                this.popupId = crossPopup.openIframe(crossPopup.getStudioUrl(1800, 277, 80), (type, payload, ID) => {
                    console.log(type);
                    switch (type) {
                        case 'IMAGE_UPLOAD':
                            const blob = new Blob(payload.parts, payload.options);
                            const file = new File([blob], `${Date.now()}-studio_${moment().format('MMDDYY_HHmmss')}.png`);
                            pressengerControl.uploadNotificationImage(file).then(uploaded => {
                                this.items.push(uploaded);
                                this.data.notificationImage = uploaded;
                                this.$emit('input', Object.assign({}, this.data));
                                crossPopup.closeAllInstances();
                                this.setStep(3, true);
                                this.next();
                            }).catch((e) => {
                                crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                    success: false,
                                    url: false,
                                });
                            });
                            break;
                        case 'GET_STUDIO_IMAGES':
                            pressengerControl.getStudioImages().then(result => {
                                crossPopup.dispatch(ID, 'GET_STUDIO_IMAGES_DONE', {
                                    success: true,
                                    images: result.map(i => Object.assign({url: getStudioImageURL(i.groupId, i.fileName)}, i)),
                                });
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'GET_STUDIO_IMAGES_DONE', {
                                    success: false,
                                });
                            });
                            break;
                        case 'UPLOAD_STUDIO_IMAGE': {
                            const ext = getExtension(payload.options.type);
                            if (ext) {
                                const blob = new Blob(payload.parts, payload.options);
                                const file = new File([blob], `${Date.now()}-studio_${moment().format('MMDDYY_HHmmss')}.${ext}`);
                                pressengerControl.uploadStudioImage(file).then(uploaded => {
                                    crossPopup.dispatch(ID, 'UPLOAD_STUDIO_IMAGE_DONE', {
                                        success: true,
                                        image: Object.assign({url: getStudioImageURL(uploaded.groupId, uploaded.fileName)}, uploaded),
                                    });
                                }).catch((e) => {
                                    crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                        success: false,
                                    });
                                });
                            } else {
                                crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                    success: false,
                                });
                            }
                            break;
                        }
                        case 'DELETE_STUDIO_IMAGE':
                            pressengerControl.deleteStudioImage(payload.fileName).then(result => {
                                crossPopup.dispatch(ID, 'DELETE_STUDIO_IMAGE_DONE', {
                                    success: true,
                                    fileName: payload.fileName,
                                });
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'DELETE_STUDIO_IMAGE_DONE', {
                                    success: false,
                                });
                            });
                            break;
                        case 'END':
                            crossPopup.closeAllInstances();
                            document.body.className = 'DisableScrolling';
                    }
                }, (this.isPushwize || this.isInflugamers) ? 'Studio StudioFull' : 'Studio');
            }
        },
        closeStudio() {
            if (this.popupId) {
                this.popupId = 0;
                this.popupName = null;
                this.popupLoading = false;
                crossPopup.closeAllInstances();
                document.body.className = '';
            }
        },
        saveStudio() {
            if (this.popupId) {
                crossPopup.dispatch(this.popupId, 'REQUEST_SAVE');
            }
        },
        openModNews() {
            if (!this.popupId) {
                document.documentElement.scrollTop = 0;
                document.body.className = 'DisableScrolling';
                this.popupName = 'mod-news';
                this.popupId = crossPopup.openIframe(crossPopup.getModNewsUrl(getCsrf(), 'android', [this.data.modNewsTemplate, this.data.modNewsText]), (type, payload, ID) => {
                    switch (type) {
                        case 'READY': {
                            crossPopup.dispatch(ID, 'LOAD_SAVED', {
                                json: this.data.modNewsAndroid?.json || null,
                                reqImages: this.data.modNewsAndroid?.reqImages || { },
                                backgrounds: Object.values(this.data.modNewsBackgrounds),
                            });
                            break;
                        }
                        case 'EXPORT': {
                            this.popupLoading = true;
                            const fileSuffix = moment().format('MMDDYY_HHmmss');
                            const blob = new Blob(payload.notificationImage.parts, payload.notificationImage.options);
                            const file = new File([blob], `${Date.now()}-modnews_${fileSuffix}.png`);
                            pressengerControl.uploadNotificationImage(file, true).then(uploaded => {
                                this.items.push(uploaded);
                                if (payload.adImage) {
                                    const adBlob = new Blob(payload.adImage.parts, payload.adImage.options);
                                    const adFile = new File([adBlob], `${Date.now()}-modnews_${fileSuffix}.png`);
                                    pressengerControl.uploadAdvertisementImage(adFile).then(adUploaded => {
                                        this.data.notificationImage = uploaded;
                                        this.data.advertisementImage = adUploaded;
                                        this.data.modNewsAndroid = {
                                            json: payload.json,
                                            reqImages: payload.reqImages,
                                        };
                                        this.popupLoading = false;
                                        this.$emit('input', Object.assign({}, this.data));
                                        crossPopup.closeAllInstances();
                                        this.next();
                                        crossPopup.dispatch(ID, 'EXPORT_DONE');
                                    }).catch(() => {
                                        crossPopup.dispatch(ID, 'EXPORT_FAILED');
                                        this.popupLoading = false;
                                    })
                                } else {
                                    this.data.notificationImage = uploaded;
                                    this.data.modNewsAndroid = {
                                        json: payload.json,
                                        reqImages: payload.reqImages,
                                    };
                                    this.popupLoading = false;
                                    this.$emit('input', Object.assign({}, this.data));
                                    crossPopup.closeAllInstances();
                                    this.next();
                                    crossPopup.dispatch(ID, 'EXPORT_DONE');

                                }
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'EXPORT_FAILED');
                            });
                            break;
                        }
                        case 'CANCEL': {
                            this.data.modNewsAndroid = {
                                json: payload.json,
                                reqImages: payload.reqImages,
                            };
                            this.$emit('input', Object.assign({}, this.data));
                            crossPopup.closeAllInstances();
                            this.next(-1);
                            crossPopup.dispatch(ID, 'EXPORT_DONE');
                            break;
                        }
                    }
                }, 'Studio');
            }
        },
        closeModNews() {
            if (this.popupId) {
                crossPopup.dispatch(this.popupId, 'REQUEST_CANCEL');
            }
        },
        nextModNews() {
            if (this.popupId) {
                crossPopup.dispatch(this.popupId, 'REQUEST_NEXT');
            }
        },
        upload() {
            this.uploadError = false;
            this.uploadDuplicateFilename = false;
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return;
            }
            if (this.checkIsDuplicateFilename(files[0].name.replace(/[^\w.-]+/g, '_'))) {
                this.uploadError = true;
                this.uploadDuplicateFilename = true;
                return;
            }
            const image = new File([files[0]], `${Date.now()}-${files[0].name.replace(/[^\w.-]+/g, '_')}`)
            this.uploading = true;
            pressengerControl.uploadNotificationImage(image).then(uploaded => {
                this.data.notificationImage = uploaded;
                this.items.push(uploaded);
            }).catch(() => {
                this.uploadError = true;
            }).finally(() => {
                this.uploading = false;
            });
        },
        select(item) {
            if (!this.data.isModNews) {
                this.setStep(3, false);
            }
            if (this.data.notificationImage && this.data.notificationImage.id === item.id) {
                this.data.notificationImage = null;
            } else {
                this.data.notificationImage = item;
            }
        },
        getImageSrc(item) {
            return getNotificationImageURL(item.groupId, item.fileName);
        },
        onPrevClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.notificationImage === null) {
                this.data.notificationImage = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.notificationImage.id) {
                    index = i;
                }
            });
            index--;
            if (index < 0) {
                index = this.sorted.length - 1;
            }
            this.data.notificationImage = this.sorted[index];
        },
        onNextClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.notificationImage === null) {
                this.data.notificationImage = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.notificationImage.id) {
                    index = i;
                }
            });
            index++;
            if (index >= this.sorted.length) {
                index = 0;
            }
            this.data.notificationImage = this.sorted[index];
        },
        friendlyName(filename, trimExt = true) {
            let name = filename;
            const prefix = name.match(/^[0-9]+-/gi);
            const ext = name.match(/.[a-z]+$/gi);
            if (prefix) {
                name = name.substring(prefix[0].length);
            }
            if (trimExt, ext) {
                name = name.substring(0, name.length - ext[0].length)
            }
            return name;
        },
        checkIsDuplicateFilename(filename) {
            const ffn = this.friendlyName(filename)
            return !!this.items.find(i => this.friendlyName(i.fileName) === ffn);
        },
    },
    destroyed() {
        // crossPopup.closeAllInstances();
        document.body.className = '';
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    if (nextVal.notificationImage && nextVal.notificationImage.fileName.indexOf('-studio_') !== -1) {
                        if (!this.data.isModNews) {
                            this.setStep(3, true);
                        }
                    } else {
                        if (!this.data.isModNews) {
                            this.setStep(3, false);
                        }
                        if (nextVal.notificationImage) {
                            const src = this.getImageSrc(nextVal.notificationImage);
                            const img = new Image();
                            img.addEventListener("load", () => {
                                if (img.width === 1800 && img.height === 277 && !this.data.isModNews) {
                                    this.setStep(3, true);
                                }
                            });
                            img.src = src;
                        }
                    }
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
    },
}
</script>

<template>
    <div class="StepTransitions">
        <ui-loading v-if="loading || uploading" />
        <template v-else>
            <div class="Grid ColumnHalf" style="padding-right: 20px; margin-bottom: 50px;" v-if="!isStudioAndUploadDisabled">
                <div class="GridItem StudioButton DisableHover" @click="openStudio()" v-if="!isStudioDisabled">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper"></div>
                </div>
                <div :class="['GridItem', 'UploadButton', 'DisableHover', 'NoBorderLeft', {Error: uploadError}]" @click="$refs.uploader.click()" v-if="!isUploadDisabled">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper">
                        <span class="GridItemErrorMessage" v-if="uploadDuplicateFilename">{{ $t('sendPressageView.uploadErrorDuplicateFilename') }}</span>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepAndroidNotificationImageUploadHint')" />
                </div>
                <div class="GridItem ModNewsButton DisableHover" @click="openModNews()" v-if="data.isModNews">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper"></div>
                </div>
            </div>
            <ui-scrollbar :height="isStudioAndUploadDisabled ? 420 : 200">
                <div class="Grid ColumnHalf">
                    <div
                        v-for="(i, index) in sorted"
                        :class="{
                            GridItem: true,
                            Active: data.notificationImage && i.id === data.notificationImage.id,
                            NoBorderLeft: index % 2 !== 0,
                            NoBorderTop: index > 1,
                        }"
                        :key="i.id"
                        @click="select(i)"
                    >
                        <div class="Toolbar">
                            <span>{{ friendlyName(i.fileName) }}</span>
                        </div>
                        <div class="ImageWrapper">
                            <img :src="getImageSrc(i)" :alt="friendlyName(i.fileName)" />
                        </div>
                        <div class="Check">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                        </div>
                    </div>
                    <div class="GridFullLoading" v-if="uploading">
                        <ui-loading />
                    </div>
                </div>
            </ui-scrollbar>
        </template>
        <div class="StudioControls" v-if="popupId">
            <div class="Back">
                <ui-button @click.native="popupName === 'studio' ? closeStudio() : closeModNews()" :disabled="popupLoading" class="clear">
                    <template v-if="popupName === 'studio'">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="15" height="14.969" viewBox="0 0 15 14.969" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.313 7.452l5.361 5.633c.41.431.41 1.129 0 1.56a1.014 1.014 0 01-1.485 0L7.728 8.906c-.093.029-.187.059-.284.059-.073 0-.143-.028-.215-.044l-5.447 5.724a1.014 1.014 0 01-1.485 0 1.145 1.145 0 010-1.56l5.32-5.59L.279 1.868a1.145 1.145 0 010-1.56 1.01 1.01 0 011.48 0l5.443 5.739c.094-.028.187-.059.283-.059.073 0 .143.028.215.044L13.13.308a1.01 1.01 0 011.48 0 1.147 1.147 0 010 1.56L9.313 7.452z"/></svg>
                        {{ $t('sendPressageView.studioClose') }}
                    </template>
                    <template v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8" height="14" viewBox="0 0 8 14" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.287 7.694l6.04 6.022a.987.987 0 001.392 0 .979.979 0 000-1.387L2.374 7l5.345-5.328a.979.979 0 000-1.387.987.987 0 00-1.392 0L.287 6.307a.983.983 0 000 1.387z"/></svg>
                        {{ $t('bottomSheet.back') }}
                    </template>
                </ui-button>
            </div>
            <div class="Next">
                <ui-button @click.native="popupName === 'studio' ? saveStudio() : nextModNews()" :disabled="popupLoading" class="clear">
                    {{ $t(popupName === 'studio' ? 'sendPressageView.studioSaveAndroidBanner' : 'bottomSheet.next')  }}
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8.03" height="14" viewBox="0 0 8.03 14" v-bind:svg-inline="''" v-bind:class="'ml-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.741 6.305L1.678.283a.993.993 0 00-1.397 0 .977.977 0 000 1.387l5.366 5.328-5.366 5.329a.977.977 0 000 1.387.993.993 0 001.397 0l6.063-6.022a.975.975 0 000-1.387z"/></svg>
                </ui-button>
            </div>
        </div>
        <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            style="display: none"
            @change="upload"
        />
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.StudioControls
    position fixed
    bottom 0
    right 0
    left 100px
    background #fff
    z-index 50
    height 100px
    display flex
    align-items center
    justify-content space-between
    overflow hidden
    transition .3s all
    .Back, .Next
        position absolute
        padding 0
        transition .3s all
        .mr-3, .ml-3
            transition .3s all
        &:before, &:after
            content ''
            position absolute
            transition .3s all
        &:before
            width 1px
            background $cBorder
            top -100px
            bottom -100px
        &:after
            width 3px
            background $cAccent
            top 5px
            bottom 5px
        &:hover:after
            width 7px
    .Next
        right 0
    .Back:before
        right 0
    .Back:after
        right -1px
    .Next:before
        left 0
    .Next:after
        left -1px
    .Back:hover
        &:after
            right -3px
        .mr-3
            transform translate(-20px,0)
    .Next:hover
        &:after
            left -3px
        .ml-3
            transform translate(20px,0)

.Grid
    display flex
    justify-content flex-start
    align-items flex-start
    align-content flex-start
    flex-wrap wrap
    min-height 100%
    box-sizing border-box
    position relative
    .GridItem
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 25%
        position relative
        border 1px solid $cBorder
        box-sizing border-box
        padding 20px
        transition .3s all
        background rgba(255,255,255,.4)
        cursor: pointer;
        &.StudioButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/studio_wide.png)
            background-size contain
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        &.ModNewsButton {
            background-color #2B2A62
            background-image url(/static/img/toolbox2/modnews_transparent.png)
            background-size 64px
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        }
        &.UploadButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/upload_transparent.png)
            background-size 64px
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
            &.Error
                background-color $cError
        &.NoBorderTop
            border-top none
        &.NoBorderLeft
            border-left none
        .Toolbar
            font-size 12px
            font-weight 600
            color $cPrimary
            align-self flex-start
            overflow hidden
            white-space nowrap
            max-width 100%
        .ImageWrapper
            overflow hidden
            height 110px
            display flex
            flex-direction column
            justify-content center
            align-items center
            img
                max-width 100%
                max-height 110px
            .GridItemErrorMessage
                display inline-block
                margin-top 20px
                font-weight 500
                font-size 12px
                text-align center
                transition .3s all
            .GridItemUploadImage
                width 100%
                height 100%
                max-width 32px
                max-height 32px
                fill: $cPrimary
                transition .3s all
        .Check
            position absolute
            opacity 0
            top 0
            left 0
            right 0
            bottom 0
            background rgba(255,255,255,.7)
            display flex
            align-items center
            justify-content center
            transition .3s all
            svg
                transform scale(2)
            path
                fill $cAccent
        .GridItemHint
            position absolute
            padding 20px
            background #fff
            border 2px solid $cBorder
            color $cPrimary
            font-size 12px
            font-weight 400
            transform: translate(-50%, -50%) scale(0);
            transition .3s all
            z-index 9999
            left: 50%;
            top: 100%;
            width: calc(100% - 40px);
            min-width 300px
        &:hover
            .GridItemHint
                transform: translate(-50%, 0) scale(1);
        &.Active
            background #fff
            transform scale(1.08)
            z-index 2
            border-color white
            box-shadow 0 40px 100px rgba(0,0,0,.2)
            .Check
                opacity 1
            img
                filter blur(3px)
        &.Error
            .ImageWrapper
                .GridItemErrorMessage
                    color $cError
                .GridItemUploadImage
                    fill $cError
        &:hover:not(.DisableHover)
            background #fff
    .GridFullLoading
        position absolute
        width 100%
        height 100%
        top 0
        left 0
        background rgba(255,255,255,.4)
        display flex
        align-items center
        justify-content center
        z-index 10
    &.ColumnHalf
        .GridItem
            width 50%
            padding 5px
            .ImageWrapper
                height 60px
            .ImageWrapper img
                max-height 80px
                max-width 100%

.StepTransitions .Scrollbar
    padding 40px 70px 150px 70px !important
    margin -40px -50px -150px -70px
    .ps__scrollbar-y-rail
        right 50px !important
        top 50px !important
</style>
